module.exports = __webpack_public_path__ + "images/backgrounds/snow/small.da5f83eace8c3f4e13f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/snow/small.jpg
// module id = BX8l
// module chunks = 1